import { Component, Inject, inject, Input, makeStateKey, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TransferState } from '@angular/platform-browser';
import { HotelInfoUiService } from '../../../services/hotel-info-ui.service';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { HotelSummaryModel, SimilarHotelsModel } from '@core/models/domains/hotel';
import { WINDOW } from '../../../accommodation-info.module';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '@shared/services/loading.service';
import { HttpParams } from '@angular/common/http';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { SharedModule } from '@shared/shared.module';
import { PdpStickyPriceDetail } from '@core/models/domains/general.model';
import { DatepickerService } from '@shared/services/datepicker.service';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';

@Component({
 selector: 'iho-pdp-ecolodge-other-units',
 standalone: true,
 imports: [CommonModule,SharedModule],
 templateUrl: './pdp-ecolodge-other-units.component.html',
 styleUrls: ['./pdp-ecolodge-other-units.component.scss'],
})
export class PdpEcolodgeOtherUnitsComponent {
    transferState = inject(TransferState);
    hotelUiService = inject(HotelInfoUiService);
    autocompleteService = inject(AutocompleteService);
    summaryKey = makeStateKey<HotelSummaryModel>('summary');
    datepickerService = inject(DatepickerService);
    hotelInfoSummary: HotelSummaryModel = {} as HotelSummaryModel;
    isCalenderPriceFetched = signal(false);

    cdnUrl = cdnUrl;
     priceDetails: WritableSignal<PdpStickyPriceDetail> = signal({} as PdpStickyPriceDetail);
    navigatorVal: any;
     persianToEnglishPipe = inject(PersianToEnglishRegexPipe);
    
    constructor(
        @Inject(WINDOW) private window: Window,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.navigatorVal = /Android|iPhone/.test(window.navigator.userAgent);
        }
        this.hotelInfoSummary = this.hotelUiService.hotelInfo();
    }

 

    @Input({ required: true })
    get dataSource(): SimilarHotelsModel {
        return this._dataSource;
    }
    set dataSource(value: SimilarHotelsModel) {
        this._dataSource = value;
    }
    private _dataSource!: SimilarHotelsModel;
    roomInfo = {} as any;

    @Input() type?: number; // type = 2 will render long-height form of card
    @Input() hotelId?: number;

    router = inject(Router);
    activatedRoute = inject(ActivatedRoute);
    loadingService = inject(LoadingService);

    goToSimilarHotel(url: any, e: Event) {
        
        e.preventDefault();
        if (isPlatformBrowser(this.platformId)) {
            let params = new HttpParams();
            this.window.scrollTo({ top: 0, behavior: 'instant' });
            this.hotelUiService.resetCountAll.set(!this.hotelUiService.resetCountAll());
            this.hotelUiService.selectedRooms.set([]);

            this.hotelUiService.hotelInfo.set({} as HotelSummaryModel);
            if (url.includes('?')) {
                let prefixUrl = url.split('?')[0];
                let UrlParams = url.split('?')[1].split('&');
                UrlParams.forEach((pair: any) => {
                    if (pair.indexOf('utm_content=') > -1) {
                        const [key, value] = ['utm_content', pair.split('utm_content=')[1]];
                        params = params.append(key, value);
                    } else {
                        const [key, value] = pair.split('=');
                        params = params.append(key, value);
                    }
                });

                let utm_medium = params.get('utm_medium');
                let utm_content = params.get('utm_content');

                this.router
                    .navigate([prefixUrl], {
                        queryParams: {
                            ...this.activatedRoute.snapshot.queryParams,
                            refer: 'hotelinfo',
                            utm_medium: utm_medium,
                            utm_content: utm_content,
                        },
                        preserveFragment: false,
                    })
                    .finally(() => {
                       this.window.scrollTo({ top: 0, behavior: 'smooth' })
                    });
            } else {
                this.router
                    .navigate([url], {
                        queryParams: {
                            ...this.activatedRoute.snapshot.queryParams,
                            refer: 'hotelinfo',
                        },
                        preserveFragment: false,
                    })
                    .finally(() => {
                       this.window.scrollTo({ top: 0, behavior: 'smooth' })
                    });
            }
        }
      
    }
  
}

